import { create } from 'zustand';

interface LastViewedMoState {
  lastViewedMoId: number | null;
  isReturnSeekPending: boolean;
  setLastViewedMoId: (moId: number) => void;
  clearReturnSeek: () => void;
}

export const useLastViewedMoStore = create<LastViewedMoState>((set) => ({
  lastViewedMoId: null,
  isReturnSeekPending: false,
  setLastViewedMoId: (moId) => set({ lastViewedMoId: moId, isReturnSeekPending: true }),
  clearReturnSeek: () => set({ isReturnSeekPending: false }),
}));
